function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect } from 'react';
import { ImageContainer, ImageComponent } from './ImageContainer';
import FixedDeviceComponent from './FixedDeviceComponent';
import ScrollButton from './ScrollButton';
import NavigationComponent from './NavigationComponent';
import ColumnsBoxComponent from './ColumnsBoxComponent';
import HeadlineComponent from './HeadlineComponent';
import MultipleColumnsComponent from './MultipleColumnsComponent';
import ProgressBar from './ProgressBar';
var ScrolledSection = function ScrolledSection(_ref) {
  var currentData = _ref.currentData,
    mobileFlag = _ref.mobileFlag,
    scrollState = _ref.scrollState,
    currentClass = _ref.currentClass,
    objectMoreData = _ref.objectMoreData;
  return /*#__PURE__*/React.createElement(React.Fragment, null, currentData && /*#__PURE__*/React.createElement("div", {
    className: "placeholder-container  ".concat(currentClass, " ").concat(mobileFlag ? 'mobile' : ''),
    style: {
      backgroundImage: currentData.indexCounter === 0 ? "url(\"".concat(objectMoreData.background.image.src, "\")") : ''
    }
  }, currentData && currentData.backgroundBottom && /*#__PURE__*/React.createElement(ImageComponent, {
    image: currentData.backgroundBottom,
    classVariation: "bottom-center ".concat(currentData.mobileImage ? 'hide-on-mobile' : ''),
    animationClass: scrollState,
    mobileFlag: mobileFlag
  }), mobileFlag && currentData.indexCounter === 0 && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("img", {
    src: objectMoreData.deviceImage.image.src,
    alt: objectMoreData.deviceImage.image.alt,
    className: "device-img"
  }), /*#__PURE__*/React.createElement(ScrollButton, {
    button: objectMoreData.scrollText,
    last: null,
    mobileFlag: true,
    setcurrentIndex: null,
    currentIndex: null
  })), /*#__PURE__*/React.createElement(ImageContainer, {
    currentData: currentData,
    scrollState: scrollState,
    mobileFlag: mobileFlag
  }), /*#__PURE__*/React.createElement("div", {
    className: "section-text "
  }, currentData.headlines && /*#__PURE__*/React.createElement(HeadlineComponent, {
    data: currentData.headlines,
    classVariation: '',
    mobileFlag: mobileFlag
  }), currentData.headlinesCentered && /*#__PURE__*/React.createElement(HeadlineComponent, {
    data: currentData.headlinesCentered,
    classVariation: 'centered',
    mobileFlag: mobileFlag
  }), currentData.headlinesWider && /*#__PURE__*/React.createElement(HeadlineComponent, {
    data: currentData.headlinesWider,
    classVariation: 'wider',
    mobileFlag: mobileFlag
  }), currentData.bottomBox && /*#__PURE__*/React.createElement(MultipleColumnsComponent, {
    multipleBox: currentData
  }), currentData.boxColumns && /*#__PURE__*/React.createElement(ColumnsBoxComponent, {
    box: currentData.boxColumns
  }), currentData.link && /*#__PURE__*/React.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: currentData.link.html.html
    }
  }))));
};
var MobileScrolledSection = function MobileScrolledSection(_ref2) {
  var scrollState = _ref2.scrollState,
    objectMoreData = _ref2.objectMoreData;
  return /*#__PURE__*/React.createElement(React.Fragment, null, objectMoreData.allPartsArr.map(function (section) {
    return /*#__PURE__*/React.createElement(ScrolledSection, {
      currentData: section,
      mobileFlag: true,
      scrollState: scrollState,
      currentClass: section.specificClass,
      objectMoreData: objectMoreData
    });
  }));
};
var OticonMoreCampaignComponent = function OticonMoreCampaignComponent(_ref3) {
  var data = _ref3.data;
  //for specific elements
  var isFirefox = /Firefox/i.test(navigator.userAgent);
  var isIE = /Trident/.test(navigator.userAgent) || /MSIE/.test(navigator.userAgent);
  var sitecoreKeys = {
    generalBackground: 'more-background',
    scrollButton: 'scroll-button',
    deviceImage: 'device-fixed-image',
    deviceDescription: 'device-fixed-description',
    headlines: 'headlines',
    background: 'background',
    learnMore: 'learn-more',
    navigation: 'navigation'
  };
  var getSectionsData = function getSectionsData(sectionData) {
    var elements = [];
    sectionData.map(function (el) {
      el.elements.anchor = el.anchor;
      elements.push(el.elements);
    });
    return elements;
  };
  var setAllParts = function setAllParts(sectionData) {
    var partsarr = [];
    var indexCounter = 0;
    sectionData.map(function (section, index) {
      section.map(function (part, i) {
        part.specificClass = "section-".concat(index, " part-").concat(i);
        part.partNumber = i;
        part.sectionNumber = index;
        part.indexCounter = indexCounter;
        part.anchor = section.anchor ? "".concat(section.anchor, "&part-").concat(i + 1) : "section-".concat(index + 1, "&part-").concat(i + 1);
        part.activeOnLoad = part.anchor && window.location.pathname.indexOf(part.anchor) > -1;
        partsarr.push(part);
        indexCounter++;
      });
    });
    return partsarr;
  };
  var objectMoreData = {
    background: data[0].preElementItems[sitecoreKeys.generalBackground] ? data[0].preElementItems[sitecoreKeys.generalBackground] : null,
    navigation: data[0].postElementItems[sitecoreKeys.navigation] ? data[0].postElementItems[sitecoreKeys.navigation] : null,
    scrollText: data[0].preElementItems[sitecoreKeys.scrollButton] ? data[0].preElementItems[sitecoreKeys.scrollButton] : null,
    deviceImage: data[0].preElementItems[sitecoreKeys.deviceImage] ? data[0].preElementItems[sitecoreKeys.deviceImage] : null,
    deviceDescription: data[0].preElementItems[sitecoreKeys.deviceDescription] ? data[0].preElementItems[sitecoreKeys.deviceDescription] : null,
    learnMore: data[0].preElementItems[sitecoreKeys.learnMore] ? data[0].preElementItems[sitecoreKeys.learnMore] : null,
    sectionData: data ? getSectionsData(data) : null,
    allPartsArr: data ? setAllParts(getSectionsData(data)) : null
  };
  var changeDataIndex = function changeDataIndex(direction) {
    var newIndex;
    if (direction === 'up') {
      newIndex = currentIndex - 1;
      if (currentIndex === 0) {
        newIndex = currentIndex;
      }
      if (currentIndex === last && specificExceptions()) {
        newIndex = currentIndex;
      }
      if (currentIndex === last && window.pageYOffset < 300 && !positionFixed) {
        newIndex = last;
        setpositionFixed(true);
      }
    } else {
      newIndex = currentIndex + 1;
      if (currentIndex === last) {
        newIndex = last;
        setpositionFixed(false);
      }
    }
    return newIndex;
  };
  var specificExceptions = function specificExceptions() {
    return last && window.pageYOffset != 0;
  };
  var checkAppPosition = function checkAppPosition(index) {
    if (index > 0 && index < last) {
      setpositionFixed(true);
    } else if (!specificExceptions()) {
      setpositionFixed(false);
    }
  };
  var handleWheel = function handleWheel(e) {
    setTimeout(function () {
      if (!scrollInProgress) {
        setscrollInProgress(true);
        if (isFirefox || isIE) {
          if (e.deltaY < 0) {
            setcurrentIndex(changeDataIndex('up'));
          }
          if (e.deltaY > 0) {
            setcurrentIndex(changeDataIndex('down'));
          }
          setScrollProgressWithDelay();
        } else {
          if (e.wheelDelta > 0) {
            setcurrentIndex(changeDataIndex('up'));
          }
          if (e.wheelDelta < 0) {
            setcurrentIndex(changeDataIndex('down'));
          }
          setScrollProgressWithDelay();
        }
      }
    }, 0);
  };
  var setScrollProgressWithDelay = function setScrollProgressWithDelay() {
    setTimeout(function () {
      setscrollInProgress(false);
    }, 1400);
  };
  var handleScroll = function handleScroll(e) {
    if (!positionFixed && (currentIndex === 0 || currentIndex === last) && !scrollInProgress) {
      if ((window.scrollY > 0 || window.pageYOffset > 0) && currentIndex === 0) {
        setscrollInProgress(true);
        setcurrentIndex(changeDataIndex('down'));
        setScrollProgressWithDelay();
      }
      if ((window.scrollY === 0 || window.pageYOffset === 0) && currentIndex === last) {
        setscrollInProgress(true);
        setpositionFixed(true);
        setScrollProgressWithDelay();
      }
      if (currentIndex === last && window.pageYOffset < 300 && e.wheelDelta > 0 && !positionFixed) {
        setscrollInProgress(true);
        setpositionFixed(true);
      }
    }
  };
  var last = objectMoreData.allPartsArr.length - 1;
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    scrollState = _useState2[0],
    setScrollState = _useState2[1];
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    currentClass = _useState4[0],
    setCurrentClass = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    mobileFlag = _useState6[0],
    setMobileFlag = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    positionFixed = _useState8[0],
    setpositionFixed = _useState8[1];
  var _useState9 = useState(false),
    _useState0 = _slicedToArray(_useState9, 2),
    scrollInProgress = _useState0[0],
    setscrollInProgress = _useState0[1];
  var _useState1 = useState(0),
    _useState10 = _slicedToArray(_useState1, 2),
    currentIndex = _useState10[0],
    setcurrentIndex = _useState10[1];
  var _useState11 = useState(objectMoreData.allPartsArr[currentIndex]),
    _useState12 = _slicedToArray(_useState11, 2),
    currentData = _useState12[0],
    setCurrentData = _useState12[1];
  var $header = document.querySelector('#header');
  var squeezedHeight = function squeezedHeight() {
    if (window.innerHeight < 690) {
      document.querySelector('html').classList.add('more-squezeed-height');
    } else {
      document.querySelector('html').classList.remove('more-squezeed-height');
    }
  };
  var checkMobileFlag = function checkMobileFlag() {
    squeezedHeight();
    setTimeout(function () {
      var isMobile = window.innerWidth < 991;
      isMobile && positionFixed ? setpositionFixed(false) : null;
      setMobileFlag(isMobile);
    }, 0);
  };
  var findIndexOnLoad = function findIndexOnLoad() {
    var indexOnInit = objectMoreData.allPartsArr.find(function (item) {
      return window.location.href.indexOf(item.anchor) > -1;
    });
    if (!mobileFlag) {
      setcurrentIndex(indexOnInit ? indexOnInit.indexCounter : 0);
    } else {
      setTimeout(function () {
        document.querySelector(".mobile.".concat(objectMoreData.allPartsArr[indexOnInit.indexCounter].specificClass.replace(' ', '.'))).scrollIntoView({
          behavior: "smooth",
          block: "start",
          inline: "start"
        });
      }, 900);
    }
  };
  useEffect(function () {
    findIndexOnLoad();
  }, [mobileFlag]);
  useEffect(function () {
    if (!mobileFlag) {
      window.addEventListener('scroll', handleScroll);
      window.addEventListener('wheel', handleWheel);
      window.addEventListener('resize', checkMobileFlag);
      window.addEventListener('popstate', findIndexOnLoad);
      squeezedHeight();
      return function () {
        window.removeEventListener('scroll', handleScroll);
        window.removeEventListener('wheel', handleWheel);
        window.removeEventListener('resize', checkMobileFlag);
        window.removeEventListener('popstate', findIndexOnLoad);
      };
    }
  });
  useEffect(function () {
    var animationClass = scrollState === ' animated-odd ' ? ' animated-even ' : ' animated-odd ';
    checkAppPosition(currentIndex);
    setCurrentData(objectMoreData.allPartsArr[currentIndex]);
    setCurrentClass(objectMoreData.allPartsArr[currentIndex] ? objectMoreData.allPartsArr[currentIndex].specificClass : null);
    if (!mobileFlag) {
      setTimeout(function () {
        return history.pushState(null, null, '?' + objectMoreData.allPartsArr[currentIndex].anchor);
      }, 10);
    }
    var timer = setTimeout(function () {
      setScrollState(animationClass);
      checkMobileFlag();
    }, 0);
    return function () {
      return clearTimeout(timer);
    };
  }, [currentIndex]);
  useEffect(function () {
    if (positionFixed) {
      document.querySelector('html').classList.add('blocked-scroll');
    } else {
      document.querySelector('html').classList.remove('blocked-scroll');
    }
  }, [positionFixed]);
  var setNextSection = function setNextSection(whichSection) {
    objectMoreData.allPartsArr.map(function (part) {
      if (part.sectionNumber === whichSection && part.partNumber === 0) {
        setcurrentIndex(part.indexCounter);
      }
    });
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "scroll-wrapper"
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      backgroundImage: "".concat('url("' + objectMoreData.background.image.src + '")'),
      position: positionFixed && !mobileFlag ? 'fixed' : 'relative',
      zIndex: positionFixed ? 'inherit' : -2,
      height: !positionFixed && !mobileFlag && currentData.indexCounter != last ? "calc(100vh - ".concat($header.offsetHeight, "px)") : 'inherit'
    },
    className: "scrolled-container " + (currentData && currentData.headlinesCentered ? 'centered' : '') + (currentData.indexCounter === 0 ? ' first ' : '')
  }, !mobileFlag && /*#__PURE__*/React.createElement(ScrolledSection, {
    currentData: currentData,
    mobileFlag: mobileFlag,
    scrollState: scrollState,
    currentClass: currentClass,
    objectMoreData: objectMoreData
  }), /*#__PURE__*/React.createElement(MobileScrolledSection, {
    mobileFlag: mobileFlag,
    scrollState: scrollState,
    currentClass: currentClass,
    objectMoreData: objectMoreData
  }), /*#__PURE__*/React.createElement(FixedDeviceComponent, {
    objectMoreData: objectMoreData,
    mobileFlag: mobileFlag
  }), currentData && !mobileFlag && /*#__PURE__*/React.createElement(NavigationComponent, {
    navigation: objectMoreData.navigation,
    activeSection: currentData.sectionNumber,
    setNextSection: setNextSection
  }), /*#__PURE__*/React.createElement(ScrollButton, {
    button: objectMoreData.scrollText,
    last: last,
    mobileFlag: false,
    setcurrentIndex: setcurrentIndex,
    currentIndex: currentIndex
  }), !mobileFlag && objectMoreData.allPartsArr && /*#__PURE__*/React.createElement(ProgressBar, {
    data: objectMoreData.allPartsArr,
    currentIndex: currentIndex,
    setcurrentIndex: setcurrentIndex
  })));
};
export default OticonMoreCampaignComponent;